import apiClient from "./api-client";

export type ServerConnection = {
  id: string;
  integration_type: "email" | "sendgrid";
  display_name: string;
  status: string;
  enabled: boolean;
  scope: "server";
};
export type EmailDelivery = {
  mode: "environment" | "server" | "disabled";
  credential_id?: string | null;
  sender?: string | null;
};
export type SenderOptions = {
  senders: string[];
  domains: string[];
  error: string | null;
};
export type ServerConnections = {
  connections: ServerConnection[];
  email: EmailDelivery;
  environment_configured: boolean;
};
export const SERVER_CONNECTIONS_PATH = "/admin/integrations/server";
const base = `/api/backend${SERVER_CONNECTIONS_PATH}`;
export const ServerConnectionsService = {
  list: () => apiClient.get<ServerConnections>(base),
  senders: (id: string) =>
    apiClient.get<SenderOptions>(`${base}/credentials/${id}/senders`),
  setEmail: (settings: EmailDelivery) =>
    apiClient.put(`${base}/email-delivery`, settings),
  setEnabled: (id: string, enabled: boolean) =>
    apiClient.patch(`${base}/credentials/${id}/enabled`, { enabled }),
  remove: (id: string) => apiClient.delete(`${base}/credentials/${id}`),
};
